import Logo from "../components/Logo";
import { Markdown } from "../components/Markdown";
import {
  committees,
  committeesCtaLabel,
  committeesHeading,
  heroCtaLabel,
  heroSecondaryCtaLabel,
  heroSloganAccent,
  heroSloganLead,
  heroTagline,
  pointsOfUnity,
  pointsOfUnityCtaLabel,
  pointsOfUnityHeading,
  pointsOfUnityIntro,
} from "../content";
import { Link, useNavigate } from "react-router-dom";
import "../styles/home.css";
import "../styles/page.css";
import "../styles/subcommittees.css";

function Home() {
  const navigate = useNavigate();
  return (
    <main id="main-content" tabIndex={-1} className="home-page" style={{ flexGrow: "3" }}>
      <section className="hero">
        <div className="hero__inner">
          <div className="hero__copy">
            <h1 className="hero__slogan">
              {heroSloganLead}
              <span className="hero__slogan-accent">{heroSloganAccent}</span>
            </h1>
            <p className="hero__tagline">{heroTagline}</p>
            <div className="hero__actions">
              <button className="hero__cta" onClick={() => navigate("/join-us")}>
                {heroCtaLabel}
              </button>
              <button
                className="hero__cta hero__cta--ghost"
                onClick={() => navigate("/detroit-divest")}
              >
                {heroSecondaryCtaLabel}
              </button>
            </div>
          </div>
          <Logo rotate className="hero__seal" />
        </div>
      </section>

      {/* Compact summary, not a replica of the full listing — the explainers
          live with their points on About. */}
      <section className="bands-section bands-section--teaser">
        <div className="bands-section__intro">
          <h2 className="bands-section__title">{pointsOfUnityHeading}</h2>
          <p className="bands-section__lede">{pointsOfUnityIntro}</p>
        </div>

        <ol className="bands-summary">
          {pointsOfUnity.map((point, i) => (
            <li key={point.id} className="bands-summary__item">
              <span className="bands-summary__num" aria-hidden="true">
                {i + 1}
              </span>
              <p className="bands-summary__text">
                <Markdown>{point.heading}</Markdown>
              </p>
            </li>
          ))}
        </ol>

        <div className="bands-section__more-wrap">
          <Link className="bands-section__more" to="/about">
            {pointsOfUnityCtaLabel}
          </Link>
        </div>
      </section>

      {/* The signs finish the heading's sentence — "Building community power
          through art, education, action" — so they sit directly beneath it with
          nothing in between. The subhead moves below them. */}
      <section className="subs subs--teaser">
        <div className="subs__intro">
          <h2 className="subs__title">{committeesHeading}</h2>
        </div>

        <ul className="subs__signs">
          {committees.map((committee) => (
            <li key={committee.id} className="subs__sign">
              {/* The icon art spells the subcommittee's name, so it is the heading. */}
              <h3 className="subs__name">
                <img className="subs__icon" src={committee.icon} alt={committee.name} />
              </h3>
            </li>
          ))}
        </ul>

        <Link className="subs__more" to="/join-us#subcommittees">
          {committeesCtaLabel}
        </Link>
      </section>
    </main>
  );
}

export default Home;
